<app-monitor-tab-group [tabs]="tabs" [activeId]="activeId" ariaLabel="SDWAN sections"
(tabSelected)="tabSelected.emit($event)">
    <ng-template monitorTab="device-config">
        <app-device-monitor-team1 [device]="device" [showHeader]="false"></app-device-monitor-team1>
    </ng-template>
    <ng-template monitorTab="qos">
        <app-device-monitor-qos [device]="device"></app-device-monitor-qos>
    </ng-template>
    <ng-template monitorTab="overlay">
        <app-device-vce-vhub [device]="device" [defaultTabIndex]="0"></app-device-vce-vhub>
    </ng-template>
    <ng-template monitorTab="overlay-plus">
        <app-device-vce-vhub-overlay-plus [device]="device" [role]="role"></app-device-vce-vhub-overlay-plus>
    </ng-template>
</app-monitor-tab-group>
